import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "field"]

  add(event) {
    event.preventDefault()
    if (!this.hasContainerTarget) return

    const benefitCount = this.fieldTargets.length
    const newField = document.createElement("div")
    newField.className = "benefit-field flex gap-2"
    newField.dataset.benefitsManagerTarget = "field"
    newField.innerHTML = `
      <input type="text"
             name="sponsor_tier[benefits][benefit_${benefitCount + 1}]"
             class="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
             placeholder="Enter benefit description">
      <button type="button"
              data-action="click->benefits-manager#remove"
              class="px-3 py-2 text-red-600 hover:text-red-800 border border-red-300 rounded-md hover:bg-red-50 transition-colors">
        Remove
      </button>
    `

    this.containerTarget.appendChild(newField)
    newField.querySelector("input")?.focus()
  }

  remove(event) {
    event.preventDefault()
    event.stopPropagation()
    event.stopImmediatePropagation()
    const field = event.target.closest('[data-benefits-manager-target="field"]')
    field?.remove()
  }
}
